<template>
  <div>
    <a
      style="color:#424242"
      tooltip="Process This Order"
      @click="
        ;(checkAlert = false),
          (dialog = true),
          (updateData.total_amount = 0),
          (theQuantity.quantity = r.quantity),
          (updateData.quantity_charge = r.quantity_charge),
          calculateTotalAmount(),
          getExchangeRate()
      "
    >
      <i class="material-icons">settings</i>
    </a>

    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="dialog"
        persistent
        max-width="1300px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitOrder($event, r.order_id)"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              >
                <span class="headline"> <strong> Process The Order <span class="text-primary ml-2">{{ r.theOrderID }}</span> </strong></span>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click.native="clearProcessOrderData(), (dialog = false), $validator.reset()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
              <div class="col-md-12">
                <div class="row" style="margin:5px 0; background-color: #FAF8F8FF;border:1px solid #bbb; border-radius: 5px;">
                    <h5 class="col-sm-12 col-md-3">
                      <strong> &nbsp;Customer ID: </strong> {{ r.user_id }}
                    </h5>
                    <h5 class="col-sm-12 col-md-4">
                      <strong>Customer Name: </strong> {{ r.full_name }}
                    </h5>
                    <h5 class="col-sm-12 col-md-5">
                      <strong>Customer Note: </strong> {{ r.customer_note }}
                    </h5>
                </div>
                <div class="row" style="margin:5px 0; background-color: #f5d7a8;border:1px solid #bbbbbb; border-radius: 5px;">
                    <h5 class="col-md-3">
                      <strong> Quantity: </strong> {{ r.quantity }}
                      <span
                        v-if="$_has_perm('edit_quantity_at_process')"
                        style="font-size: 15px"
                      >
                        <a @click="openEditQuantityModal(r.order_id)">edit?</a>
                      </span>
                    </h5>
                    <h5  class="col-md-3" v-if="$_has_perm('edit_size_at_process')">
                      <strong>Size: </strong> {{ r.size }}
                      <span style="font-size: 15px">
                        <a @click="openEditSizeModal(r.size, r.order_id)">edit?</a>
                      </span>
                    </h5>
                    <h5  class="col-md-3" v-if="$_has_perm('edit_color_at_process')">
                      <strong>Color: </strong> {{ r.color }}
                      <span style="font-size: 15px">
                        <a @click="openEditColorModal(r.color, r.order_id)">edit?</a>
                      </span>
                    </h5>
                    <h5  class="col-md-3">
                      <strong>Type: </strong> {{ r.type }}
                      <span style="font-size: 15px">
                        <a @click="openEditTypeModal(r.type, r.order_id)">edit?</a>
                      </span>
                    </h5>
                  </div>
                <div class="col-md-8" style="padding: 0px;">
                  <div class="row" style="margin:5px 0; background-color: #FAF8F8FF;border:1px solid #FF0101FF; border-radius: 5px;">
                    <h5  class="col-md-12">
                      <strong>Order Note: </strong> {{ r.note }}
                    </h5>
                  </div>
                  <div class="row" style="margin:5px 0; background-color: #FAF8F8FF;border:1px solid #bbb; border-radius: 5px;">
                    <h5 class="col-sm-12 col-md-6">
                      <strong> Product Url:</strong>
                      <a
                        :href="r.product_url"
                        target="_blank"
                      >{{
                        r.product_url.replace(/http(s)?:\/\//, '').substr(0, 20) +
                          (r.product_url.length > 25 ? '...' : '')
                      }}</a>
                      &nbsp;
                      <span
                        v-if="$_has_perm('edit_url_at_process')"
                        style="font-size: 15px"
                      >
                        <a @click="openEditProductUrlModal(r.product_url, r.order_id)">edit?</a>
                      </span>
                    </h5>
                    <h5 class="col-sm-12 col-md-6">
                      <strong>Warehouse: </strong>
                      {{ r.country }}
                      <span style="font-size: 15px"><a @click="openEditWarehouseModal(r.warehouse_id_fk, r.order_id)">edit?</a></span>
                    </h5>
                    <h5
                      class="col-sm-12 col-md-6"
                      style="color: #FF0101FF"
                    >
                      <strong>{{ r.transportation_type_obj ? r.transportation_type_obj.name : '' }}</strong>
                      <span style="font-size: 15px"><a @click="openEditTransportationTypeModal(r)">edit?</a></span>
                    </h5>
                    <h5
                      class="col-sm-12 col-md-6"
                    >
                      <strong> Price Per Weight USA: </strong> ${{ r.item_weight_price_usa }}
                      <span style="font-size: 15px">
                        <a @click="openEdit2Modal(r.user_id)">edit?</a>
                      </span>
                    </h5>
                    <h5
                      v-if="r.coupon != null"
                      class="col-sm-12 col-md-12"
                    >
                      <strong> Coupon: </strong> {{ r.coupon }}
                      <span style="font-size: small"><strong>percentage:</strong> </span>
                      {{ r.percentage }}%
                    </h5>
                  </div>
                </div>
                <div class="col-md-4" style="padding: 0px;">
                  <div style="margin:5px 0 0 5px;border:1px solid #bbb;border-radius: 5px;">
                    <img
                      v-if="r.image"
                      :src="`${$_image_path()}${r.image}`"
                      alt="Image"
                      width="100%"
                      height="146px"
                      style="border-radius: 4px; object-fit: contain; cursor: pointer;"
                      @click="showImage(r.image)"
                    >
                    <img
                      v-else
                      src="../../assets/images/black_shipzone.png"
                      alt="Image"
                      width="100%"
                      height="146px"
                      style="border-radius: 4px; object-fit: contain; cursor: pointer;"
                    >
                  </div>
                  </div>
              </div>

              <!-- <h5
                class="col-sm-12 col-md-3"
                v-if="r.country == 'Turkey'"
              >
                <strong> Quantity Charge <span style="font-size: small">base</span>: </strong>
                {{ r.quantity_charge_base_turkey }}
                <span style="font-size: 15px">
                  <a @click="openEditQttBaseTurkeyModal(r.user_id, r.order_id)">edit?</a>
                </span>
              </h5>
              <h5
                class="col-sm-12 col-md-3"
                v-else
              >
                <strong> Quantity Charge <span style="font-size: small">base</span>: </strong>
                {{ r.quantity_charge_base_usa }}
                <span style="font-size: 15px">
                  <a @click="openEditQttBaseUSAModal(r.user_id, r.order_id)">edit?</a>
                </span>
              </h5>
              <h5
                class="col-sm-12 col-md-3"
                v-if="r.country == 'Turkey'"
              >
                <strong> Quantity Charge <span style="font-size: small">other</span>: </strong>
                {{ r.quantity_charge_other_turkey }}
                <span style="font-size: 15px">
                  <a @click="openEditQttOtherTurkeyModal(r.user_id, r.order_id)">edit?</a>
                </span>
              </h5>
              <h5
                class="col-sm-12 col-md-3"
                v-else
              >
                <strong> Quantity Charge <span style="font-size: small">other</span>: </strong>
                {{ r.quantity_charge_other_usa }}
                <span style="font-size: 15px">
                  <a @click="openEditQttOtherUSAModal(r.user_id, r.order_id)">edit?</a>
                </span>
              </h5> -->
              <!-- <h5
                v-if="r.country === 'Turkey'"
                class="col-sm-12 col-md-3"
              >
                <strong> Price Per Weight Turkey: </strong> ${{ r.item_weight_price_turkey }}
                <span style="font-size: 15px">
                  <a @click="openEdit1Modal(r.user_id)">edit?</a>
                </span>
              </h5> -->

              <!-- <h5 class="col-sm-12 col-md-3">
                <strong> DeliveryType:</strong>officeDelivery<span style="font-size: 15px"> -->
                  <!-- <a @click="openEditDeliveryTypeModal(r.order_id)">edit?</a> -->
                <!-- </span>
              </h5> -->


              <div class="row">
                <!-- <div class="col-sm-10">
                  <div class="row"> -->
                    <!-- <h5
                      v-if="r.country == 'Turkey'"
                      class="col-sm-12 col-md-12"
                    >
                      <strong> &nbsp; Tip: </strong>
                      <span style="text-decoration: underline">ShipZone Fee</span> is
                      <b>${{ defaultPriceData.kreenex_fee_turkey }}</b> if
                      <i style="text-decoration: underline"> Item price</i> less than
                      <b>${{ defaultPriceData.kreenex_fee_base_turkey }}</b>, if <i style="text-decoration: underline">Item price </i> is more we get ShipZone
                      fee by this function
                      <i style="text-decoration: underline">
                        {{ defaultPriceData.kreenex_fee_turkey }} + (item price *
                        {{ defaultPriceData.kreenex_fee_percentage }})</i>
                    </h5> -->
                    <!-- <h5
                      v-else
                      class="col-sm-12 col-md-12"
                    >
                      <strong> &nbsp; Tip: </strong>
                      <span style="text-decoration: underline">ShipZone Fee</span> is
                      <b>${{ defaultPriceData.kreenex_fee_usa }}</b> if
                      <i style="text-decoration: underline"> Item price</i> less than
                      <b>${{ defaultPriceData.kreenex_fee_base_usa }}</b>, if <i style="text-decoration: underline">Item price </i> is more we get ShipZone
                      fee by this function
                      <i style="text-decoration: underline">
                        {{ defaultPriceData.kreenex_fee_usa }} + (item price *
                        {{ defaultPriceData.kreenex_fee_percentage }})</i>
                    </h5> -->
                  <!-- </div>
                </div> -->

              </div>
            </v-card-title>

            <v-card-text>
              <v-alert
                type="success"
                :value="checkAlert"
              >
                The Order is Processed
              </v-alert>

              <v-layout wrap>
                <v-flex
                  class="px-2"
                  v-if="r.country === 'Turkey'"
                  xs12
                  sm12
                  md3
                  lg2
                >
                  <v-text-field
                    label="Item Price TL*"
                    v-model.number="updateData.the_tl_price"
                    @input="calculateUSDPrice(updateData.the_tl_price, r.country)"
                    @change="calculateUSDPrice(updateData.the_tl_price, r.country)"
                    :error-messages="errors.collect('Item price TL')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="Item price TL"
                  ></v-text-field>
                </v-flex>
                <div class="col-md-12" style="color:#2d315c;border-bottom:1px solid #2d315c;margin-bottom:5px;">
                  <h4>Calculate Fees</h4>
                </div>
                <v-flex
                  class="px-2"
                  v-if="r.country === 'Turkey'"
                  xs12
                  sm12
                  md3
                  lg2
                >
                  <v-text-field
                    label="Item Price USD*"
                    v-model.number="updateData.item_price"
                    @input="
                        calculateKreenexFee(
                          updateData.item_price,
                          defaultPriceData.kreenex_fee_percentage,
                          r.country
                        ),
                          calculateTotalAmount()
                      "
                    @change="
                        calculateKreenexFee(
                          updateData.item_price,
                          defaultPriceData.kreenex_fee_percentage,
                          r.country
                        ),
                          calculateTotalAmount()
                      "
                    :error-messages="errors.collect('Item price USD')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="Item price USD"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="px-2"
                  v-else
                  xs12
                  sm12
                  md6
                  lg3
                >
                  <v-text-field
                    label="Item Price*"
                    v-model.number="updateData.item_price"
                    @input="
                        calculateKreenexFee(
                          updateData.item_price,
                          defaultPriceData.kreenex_fee_percentage,
                          r.country
                        ),
                          calculateTotalAmount()
                      "
                    @change="
                        calculateKreenexFee(
                          updateData.item_price,
                          defaultPriceData.kreenex_fee_percentage,
                          r.country
                        ),
                          calculateTotalAmount()
                      "
                    :error-messages="errors.collect('Item price')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="Item price"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg3
                >
                  <v-text-field
                    label="International Tax"
                    v-model.number="updateData.national_tax"
                    @input="calculateTotalAmount()"
                    @change="calculateTotalAmount()"
                    :error-messages="errors.collect('International Tax')"
                    v-validate="'decimal:2'"
                    data-vv-name="International Tax"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg3
                >
                  <v-text-field
                    label="Delivery Price"
                    v-model.number="updateData.delivery_price"
                    @input="calculateTotalAmount()"
                    @change="calculateTotalAmount()"
                    :error-messages="errors.collect('Delivery price')"
                    v-validate="'decimal:2'"
                    data-vv-name="Delivery price"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg3
                >
                  <v-text-field
                    label="Quantity Charge"
                    v-model.number="updateData.quantity_charge"
                    @input="calculateTotalAmount()"
                    :error-messages="errors.collect('Quantity charge')"
                    v-validate="'decimal:2'"
                    data-vv-name="Quantity charge"
                    :readonly="!$_has_perm('add_quantity_charge_at_process')"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg3
                  v-if="r.country == 'Turkey'"
                >
                  <v-select
                    autocomplete
                    :items="itemTypes"
                    v-model="updateData.item_type"
                    :error-messages="errors.collect('Item type')"
                    data-vv-name="Item type"
                    label="Item type*"
                    v-validate="'required'"
                    single-line
                    @input="
                        calculateIntShipping3(
                          r.coupon,
                          r.percentage,
                          updateData.item_type,
                          r.quantity
                        ),
                          calculateTotalAmount()
                      "
                  ></v-select>
                </v-flex>
                <v-flex
                  class="px-2"
                  v-else
                  xs12
                  sm12
                  md6
                  lg3
                >
                  <v-text-field
                    label="Item Weight"
                    v-model.number="updateData.item_weight"
                    @input="
                        calculateIntShipping(
                          r.country,
                          r.coupon,
                          r.percentage,
                          r.item_weight_price_turkey,
                          r.item_weight_price_usa,
                          r.quantity
                        ),
                          calculateTotalAmount()
                      "
                    @change="
                        calculateIntShipping(
                          r.country,
                          r.coupon,
                          r.percentage,
                          r.item_weight_price_turkey,
                          r.item_weight_price_usa,
                          r.quantity
                        ),
                          calculateTotalAmount()
                      "
                    :error-messages="errors.collect('Item weight')"
                    v-validate="'decimal'"
                    data-vv-name="Item weight"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  v-if="r.coupon == null"
                  xs12
                  sm12
                  md6
                  lg3
                >
                  <v-text-field
                    label="Int Shipping"
                    v-model.number="updateData.internal_shipping_handling"
                    @input="calculateTotalAmount()"
                    @change="calculateTotalAmount()"
                    :error-messages="errors.collect('Int. Shipping')"
                    v-validate="'decimal:2'"
                    data-vv-name="Int. Shipping"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  v-if="r.coupon != null"
                  xs12
                  sm12
                  md3
                  lg3
                >
                  <v-text-field
                    label="Int Shipping"
                    v-model.number="temp_shipping"
                    @input="
                        calculateIntShipping2(
                          temp_shipping,
                          r.country,
                          r.coupon,
                          r.percentage,
                          r.item_weight_price_turkey,
                          r.item_weight_price_usa,
                          r.quantity
                        ),
                          calculateTotalAmount()
                      "
                    @change="
                        calculateIntShipping2(
                          temp_shipping,
                          r.country,
                          r.coupon,
                          r.percentage,
                          r.item_weight_price_turkey,
                          r.item_weight_price_usa,
                          r.quantity
                        ),
                          calculateTotalAmount()
                      "
                    :error-messages="errors.collect('Int. Shipping')"
                    v-validate="'decimal:2'"
                    data-vv-name="Int. Shipping"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  v-if="r.coupon != null"
                  xs12
                  sm12
                  md3
                  lg3
                >
                  <v-text-field
                    label="Discounted shipping price"
                    v-model.number="updateData.internal_shipping_handling"
                    @input="calculateTotalAmount()"
                    @change="calculateTotalAmount()"
                    :error-messages="errors.collect('Int. Shipping')"
                    v-validate="'decimal:2'"
                    data-vv-name="Int. Shipping"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg3
                >
                  <v-text-field
                    label="Local Tax"
                    v-model.number="updateData.tax"
                    @input="calculateTotalAmount()"
                    @change="calculateTotalAmount()"
                    :error-messages="errors.collect('tax')"
                    v-validate="'decimal:2'"
                    data-vv-name="tax"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg3
                >
                  <v-text-field
                    label="ShipZone Fee"
                    v-model.number="updateData.kreenex_fee"
                    @input="calculateTotalAmount()"
                    @change="calculateTotalAmount()"
                    :error-messages="errors.collect('ShipZone fee')"
                    v-validate="'decimal:2'"
                    data-vv-name="ShipZone fee"
                    :readonly="!$_has_perm('add_company_fee_at_process')"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg3
                >
                  <v-text-field
                    label="Insurance"
                    v-model.number="updateData.insurance"
                    @input="calculateTotalAmount()"
                    @change="calculateTotalAmount()"
                    :error-messages="errors.collect('insurance')"
                    v-validate="'decimal:2'"
                    data-vv-name="insurance"
                  ></v-text-field>
              </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg3
                  v-if="$_has_perm('add_discount_at_process')"
                >
                  <v-text-field
                    label="Discount"
                    @input="calculateTotalAmount()"
                    @change="calculateTotalAmount()"
                    v-model.number="updateData.discount"
                    :error-messages="errors.collect('Discount')"
                    v-validate="'decimal:2'"
                    data-vv-name="Discount"
                  ></v-text-field>
                </v-flex>

                <div class="d-flex align-center pl-3 mt-3" style="gap: 24px;">
                      <v-checkbox
                        v-model="updateData.is_repackage"
                        label="Repackage"
                        color="primary"
                        hide-details
                        class="ma-0 pa-0"
                        style="font-size: 16px; margin-bottom: 0; min-width: 150px;"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="updateData.is_hold"
                        label="Hold"
                        color="primary"
                        hide-details
                        class="ma-0 pa-0"
                        style="font-size: 16px; margin-bottom: 0; min-width: 90px;"
                      ></v-checkbox>
                    </div>

                <v-layout row wrap class="col-md-12">

                    <v-flex
                      v-if="updateData.other_service"
                      class="px-2"
                      xs12
                      sm12
                      md6
                      lg3
                    >
                      <v-text-field
                          label="Other Service Price"
                          v-model.number="updateData.other_service_price"
                          @input="calculateTotalAmount()"
                          @change="calculateTotalAmount()"
                          :error-messages="errors.collect('Other Service Price')"
                          v-validate="'decimal:2'"
                          data-vv-name="Other Service Price"
                        ></v-text-field>
                    </v-flex>

                  <v-flex
                    class="px-2"
                    v-if="updateData.is_repackage"
                    xs12
                    sm12
                    md6
                    lg4
                  >
                    <v-text-field
                      label="Repackage Price"
                      v-model.number="updateData.repackage_price"
                      @input="calculateTotalAmount()"
                      @change="calculateTotalAmount()"
                      :error-messages="errors.collect('Repackage Price')"
                      v-validate="'decimal:2'"
                      data-vv-name="Repackage Price"
                    ></v-text-field>
                  </v-flex>


                  <v-flex
                    class="px-2"
                    v-if="updateData.is_hold"
                    xs12
                    sm12
                    md6
                    lg4
                  >
                    <v-text-field
                      label="Hold Price"
                      v-model.number="updateData.hold_price"
                      @input="calculateTotalAmount()"
                      @change="calculateTotalAmount()"
                      :error-messages="errors.collect('Hold Price')"
                      v-validate="'decimal:2'"
                      data-vv-name="Hold Price"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <div class="col-md-12" style="color:#2d315c;border-bottom:1px solid #2d315c;margin-bottom:5px;">
                  <h4>Select Dates</h4>
                </div>
                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg4
                >
                  <date-picker
                    label="Total Amount"
                    style="margin-top: 3%; border-bottom-color: #919191;"
                    :date="startTime2"
                    :option="option2"
                    class="form-control"
                  ></date-picker>
                </v-flex>
                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg4
                >
                  <date-picker
                    style="margin-top: 4%; border-bottom-color: #919191"
                    :date="startTime"
                    :option="option"
                    class="form-control"
                  ></date-picker>
                  <span
                    v-if="fromDateError"
                    style="color: orangered"
                  ><br />From date must be greater than Today</span>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg4
                >
                  <date-picker
                    style="margin-top: 4%; border-bottom-color: #919191"
                    :date="startTime1"
                    :option="option1"
                    class="form-control"
                  ></date-picker>
                  <span
                    v-if="toDateError"
                    style="color: orangered"
                  ><br />To date must be greater than From date</span>
                </v-flex>

                <!-- <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md9
                  lg6
                >
                  <v-text-field
                    label="Description"
                    v-model="updateData.description"
                  ></v-text-field>
                </v-flex> -->
                <v-layout wrap class="col-md-12">
                <!-- <v-flex
                  xs12
                  sm4
                  md4
                  lg4
                >
                  <v-select
                    :items="transportationTypes"
                    item-value="id"
                    item-text="name"
                    v-model="updateData.transportation_type"
                    :error-messages="errors.collect('Transportation Type')"
                    data-vv-name="Transportation Type"
                    label="Transportation Type*"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex> -->


              </v-layout>
              <div class="col-md-12" style="color:#2d315c;border-bottom:1px solid #2d315c;margin:10px 0;">
                  <h4>Notes</h4>
                </div>
                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md12
                  lg4
                >
                  <v-text-field
                    label="Admin Process note"
                    v-model="updateData.process_note"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md12
                  lg4
                >
                  <v-text-field
                    label="Customer Process note"
                    v-model="updateData.customer_process_note"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  lg4>
                  <div class="col-md-12 d-flex align-items-center">
                    <v-btn
                      block
                      @click="triggerFileInput"
                      style="margin: 16px;max-width: 300px; display: flex; align-items: center; justify-content: center;"
                    >
                      Upload Image
                    </v-btn>
                    <input
                      type="file"
                      ref="fileInput"
                      style="display: none"
                      accept="image/*"
                      v-validate="'max_file_size:2'"
                      data-vv-name="file"
                      @change="handleFileUpload"
                    />
                    <img
                      v-if="imagePreview"
                      :src="imagePreview"
                      alt="Preview"
                      style="width: 70px; height: 70px; object-fit: cover; border: 1px solid #ccc; flex:none !important"
                    />
                    <span
                      v-if="updateData.fileName"
                      style="margin-left: 15px; display: flex; align-items: center;"
                    >
                      {{ updateData.fileName }}
                    </span>
                  </div>
                </v-flex>
                <v-flex
                  class="px-2"
                  v-if="updateData.other_service"
                  xs12
                  sm5
                  lg4
                >
                  <v-text-field
                    label="Other service note"
                    v-model="updateData.other_service"
                    data-vv-name="other_service"
                    readonly
                  >
                  </v-text-field>
                </v-flex>
              <div class="col-md-12" style="color:#2d315c;border-bottom:1px solid #2d315c;margin-bottom:10px;">
                  <h4>Summary Price</h4>
                </div>
                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg3
                >
                  <v-text-field
                    label="Purchase Cost"
                    v-model.number="caculatePurchaseCost"
                    :readonly="true"
                    :style="{ backgroundColor: 'white', color: '#2d2d2d', opacity: 1 }"
                    class="no-disabled-style"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg3
                >
                  <v-text-field
                    label="Total Amount"
                    v-model.number="updateData.total_amount"
                    :error-messages="errors.collect('total_amount')"
                    v-validate="'decimal:2'"
                    data-vv-name="total_amount"
                  ></v-text-field>
                </v-flex>

                <!-- <v-flex
                  class="px-2"
                  xs12
                  sm3
                  md2
                >
                  <v-checkbox
                    style="padding: 0px"
                    label="Send SMS"
                    v-model="updateData.send_sms"
                    color="indigo"
                  ></v-checkbox>
                </v-flex> -->
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto;color: #989595;"
                @click.native="clearProcessOrderData(), (dialog = false), $validator.reset()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 1.5%"
                outline
                class="blue-logout"
              >Save</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>

    <edit-price-for-turkey
      :edit1Modal="edit1Modal"
      :edit1Data="edit1Data"
      :closeEdit1Modal="closeEdit1Modal"
      :editPriceForTurkey="editPriceForTurkey"
      :seccessAlert="seccessAlert"
    >
    </edit-price-for-turkey>

    <edit-price-for-usa
      :edit2Modal="edit2Modal"
      :edit2Data="edit2Data"
      :closeEdit2Modal="closeEdit2Modal"
      :editPriceForUSA="editPriceForUSA"
      :seccessAlert="seccessAlert"
    >
    </edit-price-for-usa>

    <edit-quantity-base-usa
      :editQttBaseUSAModal="editQttBaseUSAModal"
      :editQttBaseUSAData="editQttBaseUSAData"
      :closeEditQttBaseUSAModal="closeEditQttBaseUSAModal"
      :editQttBaseUSA="editQttBaseUSA"
      :seccessAlert="seccessAlert"
    >
    </edit-quantity-base-usa>

    <edit-quantity-other-usa
      :editQttOtherUSAModal="editQttOtherUSAModal"
      :editQttOtherUSAData="editQttOtherUSAData"
      :closeEditQttOtherUSAModal="closeEditQttOtherUSAModal"
      :editQttOtherUSA="editQttOtherUSA"
      :seccessAlert="seccessAlert"
    >
    </edit-quantity-other-usa>

    <edit-quantity-base-turkey
      :editQttBaseTurkeyModal="editQttBaseTurkeyModal"
      :editQttBaseTurkeyData="editQttBaseTurkeyData"
      :closeEditQttBaseTurkeyModal="closeEditQttBaseTurkeyModal"
      :editQttBaseTurkey="editQttBaseTurkey"
      :seccessAlert="seccessAlert"
    >
    </edit-quantity-base-turkey>

    <edit-quantity-other-turkey
      :editQttOtherTurkeyModal="editQttOtherTurkeyModal"
      :editQttOtherTurkeyData="editQttOtherTurkeyData"
      :closeEditQttOtherTurkeyModal="closeEditQttOtherTurkeyModal"
      :editQttOtherTurkey="editQttOtherTurkey"
      :seccessAlert="seccessAlert"
    >
    </edit-quantity-other-turkey>

    <edit-delivery-type
      :deliveryTypeModal="deliveryTypeModal"
      :editDeliveryTypeData="editDeliveryTypeData"
      :closeEditDeliveryTypeModal="closeEditDeliveryTypeModal"
      :editDeliveryType="editDeliveryType"
      :seccessAlert="seccessAlert"
      :deliveryTypes="deliveryTypes"
    >
    </edit-delivery-type>

    <edit-quantity
      :quantityModal="quantityModal"
      :editQuantityData="editQuantityData"
      :closeEditQuantityModal="closeEditQuantityModal"
      :editQuantity="editQuantity"
      :seccessAlert="seccessAlert"
    >
    </edit-quantity>

    <edit-product-url
      :seccessAlert="seccessAlert"
      :editProductUrlModal="editProductUrlModal"
      :closeEditProductUrlModal="closeEditProductUrlModal"
      :editProductUrlData="editProductUrlData"
      :editProductUrl="editProductUrl"
      :UrlError="UrlError"
    ></edit-product-url>

    <edit-warehouse
      :seccessAlert="seccessAlert"
      :editWarehouseModal="editWarehouseModal"
      :closeEditWarehouseModal="closeEditWarehouseModal"
      :editWarehouseData="editWarehouseData"
      :editWarehouse="editWarehouse"
      :warehouses="warehouses"
    ></edit-warehouse>

    <edit-size
      :seccessAlert="seccessAlert"
      :editSizeModal="editSizeModal"
      :closeEditSizeModal="closeEditSizeModal"
      :editSizeData="editSizeData"
      :editSize="editSize"
    ></edit-size>

    <edit-color
      :seccessAlert="seccessAlert"
      :editColorModal="editColorModal"
      :closeEditColorModal="closeEditColorModal"
      :editColorData="editColorData"
      :editColor="editColor"
    ></edit-color>

    <edit-type
      :seccessAlert="seccessAlert"
      :editTypeModal="editTypeModal"
      :closeEditTypeModal="closeEditTypeModal"
      :editTypeData="editTypeData"
      :editType="editType"
    ></edit-type>

    <edit-transportation-type
      :form="orderObj"
      :editTransTypeModal="editTransTypeModal"
      @close="editTransTypeModal = false"
      @update-data="getResults(), updateData.transportation_type = r.transportation_type"
    />

    <v-dialog
      v-model="imgDialog"
      max-width="500px"
    >
      <v-card>
        <img
          :src="`${$_image_path()}${theImage}`"
          alt="Image"
          width="100%"
          height="100%"
          style="border-radius: 4px"
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import editPriceForTurkey from './user/editPriceForTurkey.vue'
import editPriceForUSA from './user/editPriceForUSA.vue'
import editQuantityBaseUsa from './user/editQuantityBaseUsa.vue'
import editQuantityOtherUsa from './user/editQuantityOtherUsa.vue'
import editQuantityBaseTurkey from './user/editQuantityBaseTurkey.vue'
import editQuantityOtherTurkey from './user/editQuantityOtherTurkey.vue'
import myDatepicker from 'vue-datepicker'
import editDeliveryType from './editDeliveryType.vue'
import editQuantity from './editQuantity.vue'
import editProductUrl from './editProductUrl.vue'
import editWarehouse from './editWarehouse.vue'
import editSize from './editSize.vue'
import editColor from './editColor.vue'
import editType from './editType.vue'
import axios from 'axios'
import swal from 'sweetalert'
import editTransportationType from './editTransportationType.vue'

export default {
  components: {
    'edit-price-for-turkey': editPriceForTurkey,
    'edit-price-for-usa': editPriceForUSA,
    'edit-quantity-base-usa': editQuantityBaseUsa,
    'edit-quantity-other-usa': editQuantityOtherUsa,
    'edit-quantity-base-turkey': editQuantityBaseTurkey,
    'edit-quantity-other-turkey': editQuantityOtherTurkey,
    'date-picker': myDatepicker,
    'edit-delivery-type': editDeliveryType,
    'edit-quantity': editQuantity,
    'edit-product-url': editProductUrl,
    'edit-warehouse': editWarehouse,
    'edit-size': editSize,
    'edit-color': editColor,
    'edit-type': editType,
    editTransportationType
  },

  props: [
    'processOrder',
    'r',
    'checkAlert',
    'updateData',
    'calculateTotalAmount',
    'loading',
    'getResults',
    'clearProcessOrderData',
    'theQuantity',
    'itemTypes',
    'defaultPriceData',
    'warehouses'
  ],

  $_veeValidate: {
    validator: 'new'
  },

  created() {
    this.getLoggedInUser()
    let t = new Date()
    let dd = t.getDate()
    let mm = t.getMonth() + 1 // January is 0!
    let yyyy = t.getFullYear()

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    t = yyyy + '-' + mm + '-' + dd
    this.today = t
    this.startTime.time = t
    this.startTime1.time = t
  },

  data() {
    return {
      editPriceForTurkeyUrl: 'api/change_price_per_weight_turkey',
      editPriceForUSAUrl: 'api/change_price_per_weight_usa',
      editQttBaseUSAUrl: 'api/change_usa_base_quantity',
      editQttOtherUSAUrl: 'api/change_usa_other_quantity',
      editQttBaseTurkeyUrl: 'api/change_turkey_base_quantity',
      editQttOtherTurkeyUrl: 'api/change_turkey_other_quantity',
      editProductUrlUrl: 'api/change_product_url',
      editWarehouseUrl: 'api/change_warehouse',
      editSizeUrl: 'api/change_size',
      editColorUrl: 'api/change_color',
      editTypeUrl: 'api/change_type',
      getActiveChangeRateUrl: 'api/get_active_exchange_rate',
      transportationTypes: [],
      activeChangeRate: [],
      exchangeBase: 0,
      the_user_id: '',
      seccessAlert: false,
      dialog: false,
      edit1Modal: false,
      fromDateError: false,
      toDateError: false,
      editQttBaseUSAModal: false,
      editQttOtherUSAModal: false,
      editQttBaseTurkeyModal: false,
      editQttOtherTurkeyModal: false,
      deliveryTypeModal: false,
      quantityModal: false,
      editProductUrlModal: false,
      editWarehouseModal: false,
      editSizeModal: false,
      editColorModal: false,
      editTypeModal: false,
      UrlError: false,
      theEditOrderID: '',
      theImage: null,
      imagePreview: null,
      file: null,
      imgDialog: false,
      orderObj: {},
      editTransTypeModal: false,
      editProductUrlData: {
        product_url: ''
      },
      editWarehouseData: {
        warehouse_id_fk: ''
      },
      editSizeData: {
        size: ''
      },
      editColorData: {
        color: ''
      },
      editTypeData: {
        type: ''
      },
      today: '',
      the_order_id: '',
      deliveryTypes: [
        { text: 'Home Delivery', value: 'home delivery' },
        { text: 'Office Delivery', value: 'office delivery' }
      ],
      editDeliveryTypeData: {
        delivery_type: ''
      },
      editQuantityData: {
        quantity: '',
        country: ''
      },
      loggedInUserData: {},
      temp_shipping: '',
      edit1Data: {
        item_weight_price_turkey: ''
      },
      edit2Modal: false,
      edit2Data: {
        item_weight_price_usa: ''
      },
      editQttBaseUSAData: {
        quantity_charge_base_usa: '',
        order_id: ''
      },
      editQttBaseTurkeyData: {
        quantity_charge_base_turkey: '',
        order_id: ''
      },
      editQttOtherUSAData: {
        quantity_charge_other_usa: '',
        order_id: ''
      },
      editQttOtherTurkeyData: {
        quantity_charge_other_turkey: '',
        order_id: ''
      },
      startTime: {
        time: ''
      },
      startTime1: {
        time: ''
      },
      startTime2: {
        time: ''
      },
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'From Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'To Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option2: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'Warehouse Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      timeoption: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD HH:mm'
      },
      multiOption: {
        type: 'multi-day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD HH:mm'
      }
    }
  },

  computed: {
    caculatePurchaseCost() {
      return Number(this.updateData.item_price * this.r.quantity +
             this.updateData.national_tax +
             this.updateData.delivery_price).toFixed(2)
    }
  },

  watch: {
    dialog(val) {
      if (val) {
        this.updateData.transportation_type = this.r.transportation_type
        this.updateData.is_repackage = this.r.is_repackage
        this.updateData.is_hold = this.r.is_hold
        this.updateData.other_service = this.r.other_service
        this.transportationTypes = this.r.warehouse.transportation_types
      }
    }
  },

  methods: {
    showImage(img) {
      this.theImage = img
      this.imgDialog = true
    },

    triggerFileInput() {
      this.$refs.fileInput.click()
    },

    handleFileUpload(event) {
      this.updateData.customer_process_note_image = null
      this.updateData.fileName = ''
      this.$validator.errors.remove('file')
      const file = event.target.files[0]
      if (file && !this.errors.has('file')) {
        this.file = file
        this.updateData.customer_process_note_image = file
        this.updateData.fileName = file.name
        this.imagePreview = URL.createObjectURL(file)
      } else {
        this.file = null
        this.updateData.customer_process_note_image = null
        this.imagePreview = null
      }
    },

    calculateUSDPrice(tlPrice, country) {
      let usdPrice = tlPrice / this.exchangeBase
      usdPrice = Number(usdPrice).toFixed(2)
      this.updateData.item_price = usdPrice

      this.calculateKreenexFee(
        this.updateData.item_price,
        this.defaultPriceData.kreenex_fee_percentage,
        country
      )
      this.calculateTotalAmount()
    },

    getExchangeRate() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getActiveChangeRateUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.activeChangeRate = []
          this.activeChangeRate = response.data.data
          let base = this.activeChangeRate.tl_price / this.activeChangeRate.usd_price
          base = Number(base).toFixed(2)
          this.exchangeBase = base
        })
    },

    openEditProductUrlModal(url, orderID) {
      this.theEditOrderID = orderID
      this.editProductUrlData.product_url = url
      this.editProductUrlModal = true
    },

    closeEditProductUrlModal() {
      this.editProductUrlData.product_url = ''
      this.editProductUrlModal = false
      this.UrlError = false
      this.seccessAlert = false
    },

    editProductUrl() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.editProductUrlUrl + '/' + this.theEditOrderID, this.editProductUrlData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.UrlError = false
          this.seccessAlert = true
          setTimeout(() => {
            this.closeEditProductUrlModal()
          }, 1500)
          this.getResults()
        })
        .catch((error) => {
          this.seccessAlert = false
          if (error.response.data.message.product_url) {
            this.UrlError = true
          }
        })
    },

    openEditTransportationTypeModal(order) {
      this.orderObj = order
      this.editTransTypeModal = true
    },

    openEditWarehouseModal(warehouse, orderID) {
      this.theEditOrderID = orderID
      this.editWarehouseData.warehouse_id_fk = warehouse
      this.editWarehouseModal = true
    },

    closeEditWarehouseModal() {
      this.theEditOrderID = ''
      this.editWarehouseData.warehouse_id_fk = ''
      this.editWarehouseModal = false
      this.seccessAlert = false
    },

    editWarehouse() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.editWarehouseUrl + '/' + this.theEditOrderID, this.editWarehouseData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(() => {
          this.seccessAlert = true
          this.getResults()
          setTimeout(() => {
            this.closeEditWarehouseModal()
          }, 1500)
        }).then(() => {
          setTimeout(() => {
            this.transportationTypes = this.r.warehouse.transportation_types
          }, 1000)
        })
    },

    openEditSizeModal(size, orderID) {
      this.theEditOrderID = orderID
      this.editSizeData.size = size
      this.editSizeModal = true
    },

    closeEditSizeModal() {
      this.theEditOrderID = ''
      this.editSizeData.size = ''
      this.editSizeModal = false
      this.seccessAlert = false
    },

    editSize() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.editSizeUrl + '/' + this.theEditOrderID, this.editSizeData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.getResults()
        })
    },

    openEditColorModal(color, orderID) {
      this.theEditOrderID = orderID
      this.editColorData.color = color
      this.editColorModal = true
    },

    openEditTypeModal(type, orderID) {
      this.theEditOrderID = orderID
      this.editTypeData.type = type
      this.editTypeModal = true
    },

    closeEditColorModal() {
      this.theEditOrderID = ''
      this.editColorData.size = ''
      this.editColorModal = false
      this.seccessAlert = false
    },

    editColor() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.editColorUrl + '/' + this.theEditOrderID, this.editColorData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.getResults()
        })
    },

    closeEditTypeModal() {
      this.theEditOrderID = ''
      this.editTypeData.type = ''
      this.editTypeModal = false
      this.seccessAlert = false
    },

    editType() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.editTypeUrl + '/' + this.theEditOrderID, this.editTypeData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.getResults()
        })
    },

    openEditQuantityModal(orderId) {
      this.quantityModal = true
      this.the_order_id = orderId
    },

    closeEditQuantityModal() {
      this.quantityModal = false
      this.editQuantityData.quantity = ''
      this.editQuantityData.country = ''
      this.seccessAlert = false
    },

    editQuantity() {
      this.editQuantityData.country = this.r.country
      let token = localStorage.getItem('access_token')
      axios
        .put('api/orders/' + this.the_order_id + '/quantity', this.editQuantityData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.updateData.quantity_charge = response.data.data.quantity_charge
          this.theQuantity.quantity = response.data.data.quantity
          this.calculateTotalAmount()
          this.seccessAlert = true
          this.editQuantityData.quantity = ''
          this.editQuantityData.country = ''
          this.the_order_id = ''
          this.getResults()
        })
        .catch(() => {
          this.editQuantityData.quantity = ''
          this.editQuantityData.country = ''
          this.the_order_id = ''
        })
    },

    openEditDeliveryTypeModal(orderId) {
      this.deliveryTypeModal = true
      this.the_order_id = orderId
    },

    closeEditDeliveryTypeModal() {
      this.deliveryTypeModal = false
      this.editDeliveryTypeData.delivery_type = ''
      this.seccessAlert = false
    },

    editDeliveryType() {
      let token = localStorage.getItem('access_token')
      axios
        .put('api/orders/' + this.the_order_id + '/delivery_type', this.editDeliveryTypeData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.editDeliveryTypeData.delivery_type = ''
          this.the_order_id = ''
          this.getResults()
        })
        .catch(() => {
          this.editDeliveryTypeData.delivery_type = ''
          this.the_order_id = ''
        })
    },

    calculateIntShipping(warehouse, coupon, percentage, priceForTurkey, priceForUsa, qtt) {
      if (coupon) {
        if (warehouse.toLowerCase() === 'turkey') {
          let shippingPrice2 = 0
          this.temp_shipping = (priceForTurkey * this.updateData.item_weight).toFixed(2)
          shippingPrice2 = this.temp_shipping - (this.temp_shipping * percentage) / 100
          shippingPrice2 = shippingPrice2 * qtt
          this.updateData.internal_shipping_handling = shippingPrice2.toFixed(2)
        } else {
          let shippingPrice1 = 0
          this.temp_shipping = (priceForUsa * this.updateData.item_weight).toFixed(2)
          shippingPrice1 = this.temp_shipping - (this.temp_shipping * percentage) / 100
          shippingPrice1 = shippingPrice1 * qtt
          this.updateData.internal_shipping_handling = shippingPrice1.toFixed(2)
        }
      } else {
        if (warehouse.toLowerCase() === 'turkey') {
          let shipPrice1 = priceForTurkey * this.updateData.item_weight
          shipPrice1 = shipPrice1 * qtt
          shipPrice1 = Number(shipPrice1).toFixed(2)
          this.updateData.internal_shipping_handling = shipPrice1
          this.temp_shipping = shipPrice1
        } else {
          let shipPrice = priceForUsa * this.updateData.item_weight
          shipPrice = shipPrice * qtt
          shipPrice = Number(shipPrice).toFixed(2)
          this.updateData.internal_shipping_handling = shipPrice
          this.temp_shipping = shipPrice
        }
      }
    },

    calculateIntShipping2(tmp, warehouse, coupon, percentage, priceForTurkey, priceForUsa, qtt) {
      if (coupon) {
        if (warehouse.toLowerCase() === 'turkey') {
          let shippingPrice2 = 0
          shippingPrice2 = tmp
          shippingPrice2 = shippingPrice2 - (shippingPrice2 * percentage) / 100
          shippingPrice2 = shippingPrice2 * qtt
          this.updateData.internal_shipping_handling = shippingPrice2.toFixed(2)
        } else {
          let shippingPrice1 = 0
          shippingPrice1 = tmp
          shippingPrice1 = shippingPrice1 - (shippingPrice1 * percentage) / 100
          shippingPrice1 = shippingPrice1 * qtt
          this.updateData.internal_shipping_handling = shippingPrice1.toFixed(2)
        }
      } else {
        if (warehouse.toLowerCase() === 'turkey') {
          let shipPrice1 = priceForTurkey * this.updateData.item_weight
          shipPrice1 = shipPrice1 * qtt
          shipPrice1 = Number(shipPrice1).toFixed(2)
          this.updateData.internal_shipping_handling = shipPrice1
          this.temp_shipping = shipPrice1
        } else {
          let shipPrice = priceForUsa * this.updateData.item_weight
          shipPrice = shipPrice * qtt
          shipPrice = Number(shipPrice).toFixed(2)
          this.updateData.internal_shipping_handling = shipPrice
          this.temp_shipping = shipPrice
        }
      }
    },

    calculateIntShipping3(coupon, percentage, itemType, qtt) {
      let itemTypeShippingPrice = 0

      let k = this.itemTypes.findIndex((item) => item.value === itemType)
      itemTypeShippingPrice = this.itemTypes[k].shippingPrice

      itemTypeShippingPrice = Number(itemTypeShippingPrice)

      if (coupon) {
        let shippingPrice3 = 0
        this.temp_shipping = itemTypeShippingPrice.toFixed(2)
        shippingPrice3 = this.temp_shipping - (this.temp_shipping * percentage) / 100
        shippingPrice3 = shippingPrice3 * qtt
        this.updateData.internal_shipping_handling = shippingPrice3.toFixed(2)
      } else {
        let shipPrice = itemTypeShippingPrice
        shipPrice = shipPrice * qtt
        shipPrice = Number(shipPrice)
        this.updateData.internal_shipping_handling = shipPrice
        this.temp_shipping = shipPrice
      }
    },

    calculateKreenexFee(itemPrice, percentage, country) {
      percentage = Number(percentage)
      if (country === 'Turkey') {
        if (itemPrice < this.defaultPriceData.kreenex_fee_base_turkey && itemPrice > 0) {
          this.updateData.kreenex_fee = this.defaultPriceData.kreenex_fee_turkey.toFixed(2)
        } else {
          this.updateData.kreenex_fee = (
            this.defaultPriceData.kreenex_fee_turkey +
            itemPrice * percentage
          ).toFixed(2)
        }
      } else {
        if (itemPrice < this.defaultPriceData.kreenex_fee_base_usa && itemPrice > 0) {
          this.updateData.kreenex_fee = this.defaultPriceData.kreenex_fee_usa.toFixed(2)
        } else {
          this.updateData.kreenex_fee = (
            this.defaultPriceData.kreenex_fee_usa +
            itemPrice * percentage
          ).toFixed(2)
        }
      }
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    submitOrder(event, id) {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.startTime.time <= this.today) {
            this.toDateError = false
            this.fromDateError = true
          } else if (this.startTime1.time <= this.startTime.time) {
            this.fromDateError = false
            this.toDateError = true
          } else {
            this.toDateError = false
            this.fromDateError = false
            this.updateData.from_date = this.startTime.time
            this.updateData.to_date = this.startTime1.time
            this.updateData.warehouse_date = this.startTime2.time
            this.updateData.tmp_shipping = this.temp_shipping
            this.temp_shipping = ''
            this.processOrder(event, id, this.startTime, this.startTime1, this.startTime2)
          }
        }
      })
    },

    openEdit1Modal(id) {
      this.edit1Modal = true
      this.the_user_id = id
    },

    closeEdit1Modal() {
      this.edit1Modal = false
      this.edit1Data.item_weight_price_turkey = ''
      this.seccessAlert = false
    },

    editPriceForTurkey() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editPriceForTurkeyUrl + '/' + this.the_user_id, this.edit1Data, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.edit1Data.item_weight_price_turkey = ''
          this.getResults()
        })
        .catch((error) => {
          this.edit1Data.item_weight_price_turkey = ''
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    openEdit2Modal(id) {
      this.edit2Modal = true
      this.the_user_id = id
    },

    closeEdit2Modal() {
      this.edit2Modal = false
      this.edit2Data.item_weight_price_usa = ''
      this.seccessAlert = false
    },

    editPriceForUSA() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editPriceForUSAUrl + '/' + this.the_user_id, this.edit2Data, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.edit2Data.item_weight_price_usa = ''
          this.getResults()
        })
        .catch((error) => {
          this.edit2Data.item_weight_price_usa = ''
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    openEditQttBaseUSAModal(id, orderId) {
      this.editQttBaseUSAModal = true
      this.the_user_id = id
      this.editQttBaseUSAData.order_id = orderId
    },

    closeEditQttBaseUSAModal() {
      this.editQttBaseUSAModal = false
      this.editQttBaseUSAData.quantity_charge_base_usa = ''
      this.seccessAlert = false
    },

    editQttBaseUSA() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editQttBaseUSAUrl + '/' + this.the_user_id, this.editQttBaseUSAData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.editQttBaseUSAData.quantity_charge_base_usa = ''
          this.getResults()
          let a = this
          setTimeout(function () {
            a.updateData.quantity_charge = a.r.quantity_charge
            a.calculateTotalAmount()
          }, 1000)
        })
        .catch((error) => {
          this.editQttBaseUSAData.quantity_charge_base_usa = ''
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    openEditQttOtherUSAModal(id, orderId) {
      this.editQttOtherUSAModal = true
      this.the_user_id = id
      this.editQttOtherUSAData.order_id = orderId
    },

    closeEditQttOtherUSAModal() {
      this.editQttOtherUSAModal = false
      this.editQttOtherUSAData.quantity_charge_base_usa = ''
      this.seccessAlert = false
    },

    editQttOtherUSA() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editQttOtherUSAUrl + '/' + this.the_user_id, this.editQttOtherUSAData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.editQttOtherUSAData.quantity_charge_base_usa = ''
          this.getResults()
          let a = this
          setTimeout(function () {
            a.updateData.quantity_charge = a.r.quantity_charge
            a.calculateTotalAmount()
          }, 1000)
        })
        .catch((error) => {
          this.editQttOtherUSAData.quantity_charge_base_usa = ''
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    openEditQttBaseTurkeyModal(id, orderId) {
      this.editQttBaseTurkeyModal = true
      this.the_user_id = id
      this.editQttBaseTurkeyData.order_id = orderId
    },

    closeEditQttBaseTurkeyModal() {
      this.editQttBaseTurkeyModal = false
      this.editQttBaseTurkeyData.quantity_charge_base_turkey = ''
      this.seccessAlert = false
    },

    editQttBaseTurkey() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editQttBaseTurkeyUrl + '/' + this.the_user_id, this.editQttBaseTurkeyData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.editQttBaseTurkeyData.quantity_charge_base_turkey = ''
          this.getResults()
          let a = this
          setTimeout(function () {
            a.updateData.quantity_charge = a.r.quantity_charge
            a.calculateTotalAmount()
          }, 1000)
        })
        .catch((error) => {
          this.editQttBaseTurkeyData.quantity_charge_base_turkey = ''
          swal('Error', `${error.response.data.message}`, 'error')
        })
    },

    openEditQttOtherTurkeyModal(id, orderId) {
      this.editQttOtherTurkeyModal = true
      this.the_user_id = id
      this.editQttOtherTurkeyData.order_id = orderId
    },

    closeEditQttOtherTurkeyModal() {
      this.editQttOtherTurkeyModal = false
      this.editQttOtherTurkeyData.quantity_charge_other_turkey = ''
      this.seccessAlert = false
    },

    editQttOtherTurkey() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editQttOtherTurkeyUrl + '/' + this.the_user_id, this.editQttOtherTurkeyData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.editQttOtherTurkeyData.quantity_charge_other_turkey = ''
          this.getResults()
          let a = this
          setTimeout(function () {
            a.updateData.quantity_charge = a.r.quantity_charge
            a.calculateTotalAmount()
          }, 1000)
        })
        .catch((error) => {
          this.editQttOtherTurkeyData.quantity_charge_other_turkey = ''
          swal('Error', `${error.response.data.message}`, 'error')
        })
    }
  }
}
</script>

<style>
.dialog-dialog--active-dialog--persistent {
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.dialog:not(.dialog--fullscreen) {
  max-height: 95%;
}

.input-group.input-group--selection-controls label {
  left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/processTheOrder.vue